import {Route, Routes} from "react-router-dom";
import Dashboard from "./Dashboard";
import UserSetting from "../container/Home/UserSetting";
import Login from "./Login";

const Home = () => {
  return (
    <Routes>
      <Route path="Dashboard" element={<Dashboard />} />
      <Route path="Setting" element={<UserSetting />} />
    </Routes>
  );
};

export default Home;
